import React, {useEffect, useState, useRef} from 'react';
import {useHistory} from 'react-router';
import {useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button, Col, FormGroup, Input, Label} from 'reactstrap';
import queryString from 'query-string';
import {apelable} from 'helpers/helpers';
import moment from 'moment';
import GridContainer from '../../../shared/GridContainer';
import FormSection from '../../../layout/FormSection';
import {
  API,
  BASE_URL,
  ESTADOS_LINEAS,
  RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO,
  RAMO_FECU_CREDITO_DOMESTICO_NEMOTECNICO,
  GEO_PAIS_CHILE_ID,
} from '../../../../CONST';
import CreditLineForm from './CreditLineForm';
import {request, get, post, put} from '../../../../helpers/requests';
import CreditLineBatchLoad from './CreditLineBatchLoad';
import CreditLineTable from './CreditLineTable';
import SafeBtn from '../../../shared/SafeBtn';
import useEasyState from '../../../shared/useState';
import {formatForBackend, validateRut} from '../../../../helpers/rutValidator';
import isUserHasProfile from '../../../../helpers/profileValidator';
import {LINEA_CREDITO_WRITE} from '../../../../helpers/profilePermission';
import WarningModal from '../../../shared/WarningModal';
import CheckModal from '../../../shared/CheckModal';

const deudorInitialState = {
  rut: '',
  name: '',
  email: '',
  phone: '',
  address: '',
  pais: null,
};
const balanceInitialState = {
  monto_vigente: 0,
  monto_solicitado: undefined,
  observacion: '',
  documentos: [],
  carpeta_tributaria: null,
};
// Campos del deudor que, al modificarse sobre un deudor existente, requieren confirmación
const DEUDOR_CAMPOS_CONFIRMACION = {
  name: 'Nombre',
  address: 'Dirección',
  email: 'Correo Electrónico',
  phone: 'Teléfono',
};
const pickDeudorCampos = (deudor) => (
  deudor && deudor.id
    ? Object.keys(DEUDOR_CAMPOS_CONFIRMACION).reduce(
      (acc, campo) => ({ ...acc, [campo]: deudor[campo] }), {},
    )
    : null
);
const normalizeCampo = (value) => (value === null || value === undefined ? '' : String(value).trim());
const lineaInitialState = {
  deudor: { ...deudorInitialState },
  tipo_deudor: null,
  balance: { ...balanceInitialState },
  estado_data: null,
};

const CreditLine = ({ policyId, locationSearch, client, handleClienteChange }) => {
  const [tiposDeudor, setTiposDeudor] = useState([]);
  const [paises, setPaises] = useState([]);
  const [poliza, setPoliza] = useState({ nemotecnico: '' });
  const { state: linea, setState: setLinea, setStateValue: setLineaProperty } = useEasyState(
    lineaInitialState,
  );
  const [edicion, setEdicion] = useState(false);
  const [lineas, setLineas] = useState([]);
  const [errors, setErrors] = useState([]);
  const [solicitandoCambios, setSolicitandoCambios] = useState(false);
  const [loadingTiposDeudor, setLoadingTiposDeudor] = useState(false);
  const [displayModalWarning, setDisplayModalWarning] = useState(false);
  const [displayModalWarningBadRequest, setDisplayModalWarningBadRequest] = useState(false);
  const [showNotFoundModal, setShowNotFoundModal] = useState(false);
  const [savingDeudor, setSavingDeudor] = useState(false);
  const [deudorStepComplete, setDeudorStepComplete] = useState(false);
  const [showDeudorExistsModal, setShowDeudorExistsModal] = useState(false);
  const [solicitada, setSolicitada] = useState(false);
  const [movPreviosCount, setMovPreviosCount] = useState(0);
  const [totalMovPreviosCount, setTotalMovPreviosCount] = useState(0);
  const [requestedChanges, setRequestedChanges] = useState(false); // para llamar al redireccionar de línea, true para testings del modal
  const [errorInForm, setErrorInForm] = useState('')
  const [isCargaMasiva, setIsCargaMasiva] = useState(false);
  const [isUnlock, setIsUnlock] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const [capturedDeudorId, setCapturedDeudorId] = useState(null);
  const [lineasCount, setLineasCount] = useState(null);

  const [storedDeudorIds, setStoredDeudorIds] = useState([]);
  const [isSiipreloadLoading, setIsSiipreloadLoading] = useState(false);

  const [rutDeudor, setrutDeudor] = useState('');
  const [idNewLine, setIdNewLine] = useState(null);
  const [lastMovement, setLastMovement] = useState('');

  const debounceTimer = useRef(null);
  const latestRutRef = useRef('');
  // Datos originales del deudor existente, para detectar si el usuario los modifica
  const originalDeudorRef = useRef(null);
  const [showDeudorChangeModal, setShowDeudorChangeModal] = useState(false);
  const [camposDeudorModificados, setCamposDeudorModificados] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
  const [showProgressModal, setShowProgressModal] = useState(false);
  
  const initialUrlParams = queryString.parse(locationSearch);
  const [isExportacionFromUrl] = useState(initialUrlParams.exportacion === 'true');

  useEffect(() => {
    const { linea_id: lineaId, retry, unlock, exportacion } = queryString.parse(locationSearch);
    const lineasCreditoUrl = `${BASE_URL}${API.lineasCredito}/${lineaId}/`;
    if (lineaId) {
      
      get(client ? `${lineasCreditoUrl}?client_id=${client.id}` : lineasCreditoUrl).then((line) => {
        const deudorData = line.deudor
        
        const isExportacion = isExportacionFromUrl || poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO;
        if (isExportacion) {
          deudorData.pais = deudorData.pais ? deudorData.pais : GEO_PAIS_CHILE_ID;
        }
        originalDeudorRef.current = pickDeudorCampos(deudorData);

        // Reintento
        if (line.balance && retry !== undefined) {
          setLinea({
            deudor: deudorData,
            tipo_deudor: line.tipo_deudor,
            balance: {
              monto_vigente: line.balance.monto_vigente,
              monto_solicitado: line.balance.monto_solicitado,
              observacion: line.balance.observacion,
              documentos: [],
              carpeta_tributaria: null,
              fecha_solicitud: line.balance.fecha_solicitud,
            },
            estado_data: line.estado_data,
          });

        }
        // Desbloqueo
        else if (line.balance && unlock !== undefined) {
          setIsUnlock(true);
          setDeudorStepComplete(true);
          setLinea({
            deudor: deudorData,
            tipo_deudor: line.tipo_deudor,
            balance: {
              monto_vigente: line.balance.monto_vigente,
              monto_solicitado: line.balance.monto_otorgado_previo,
              observacion: line.balance.observacion,
              documentos: [],
              carpeta_tributaria: null,
              fecha_solicitud: line.balance.fecha_solicitud,
            },
            estado_data: line.estado_data,
          });
        }
        // Apelación
        else if (line.estado_data && line.estado_data.nemotecnico === ESTADOS_LINEAS.rechazada && line.balance.is_migration == false &&
          apelable(line.balance.fecha_respuesta)) {
          setDeudorStepComplete(true);
          setLinea({
            deudor: deudorData,
            tipo_deudor: line.tipo_deudor,
            balance: {
              monto_vigente: line.balance.monto_vigente,
              monto_solicitado: 0,
              limite_apelacion: line.balance.monto_solicitado,
              observacion: line.balance.observacion,
              documentos: [],
              carpeta_tributaria: null,
              fecha_solicitud: line.balance.fecha_solicitud,
            },
            estado_data: line.estado_data,
          });
        }
        // Solicitar
        else if (line.balance && line.balance.fecha_respuesta) {
          setDeudorStepComplete(true);
          setLinea({
            deudor: deudorData,
            tipo_deudor: line.tipo_deudor,
            balance: {
              monto_vigente: line.balance.monto_vigente,
              monto_solicitado: 0,
              observacion: '',
              documentos: [],
              carpeta_tributaria: null,
              fecha_solicitud: line.balance.fecha_solicitud,
            },
            estado_data: line.estado_data,
          });
        }
      });
      history.push({
        pathname: `/asegurado/linea-credito/${policyId}`,
        state: location.state,
      });
    }
  }, []);

  useEffect(() => {
    // Buscamos la póliza
    const creditosUrl = `${BASE_URL}${API.creditos}/${policyId}/`;
    get(client ? `${creditosUrl}?client_id=${client.id}` : creditosUrl)
      .then((resp) => {
        if (!client) {
          // Si no hay cliente en los props (o sea se ingresó a través
          // de la url en una pestaña nueva), se obtiene el cliente
          // mediante la póliza.
          const clientData = resp.balance?.asegurado || resp.borrador?.asegurado;
          handleClienteChange({ value: clientData });
        }

        // Si balance es null, usar borrador como fallback
        if (resp.balance === null && resp.borrador) {
          resp.balance = resp.borrador;
        }
        return setPoliza(resp);
      })
      .catch((err) => {
        if (err.status === 404) {
          // Si no existe la póliza, se redirige a la página de líneas de crédito.
          setShowNotFoundModal(true);
        }
      });
  }, [policyId]);

  useEffect(() => {
    if (poliza.nemotecnico) {
      // Buscamos los tipos de deudor
      get(`${BASE_URL}${API.tiposDeudor}/`).then((resp) => {
        if (!poliza.balance.clientes_innominados) {
          setTiposDeudor(resp.filter(tipo => tipo.nemotecnico !== 'innominado'))
        }
        else {
          setTiposDeudor(resp)
        }
      });
    }
  }, [poliza])

  // Fetch paises solo cuando es poliza de exportacion
  useEffect(() => {
    if (poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO) {
      get(`${BASE_URL}${API.paises}/`).then(setPaises);
    }
  }, [poliza.ramo_fecu_nemotecnico]);

  const handleDeudorRutChange = (newRut) => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    setDeudorStepComplete(false);
    originalDeudorRef.current = null;

    if (newRut.length === 0) { //cuando se borra el rut, sin LIMPIAR, se toma el rut como vacío y reinicia la linea
      setLinea((prevLinea) => ({
        ...lineaInitialState,
        deudor: { ...deudorInitialState, pais: prevLinea.deudor.pais },
      }));
      return;
    }

    const isExportacion = poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO;
    const isChileanRut = !isExportacion || linea.deudor.pais === GEO_PAIS_CHILE_ID;

    let backendRut;
    let isValidId = false;
    const FOREIGN_ID_MIN_SIZE = 6;

    if (isChileanRut) {
      const validatedRut = validateRut(newRut);
      backendRut = formatForBackend(validatedRut.formatted);
      isValidId = validatedRut.isValid;
    } else {
      backendRut = newRut.replace(/\s/g, '');
      isValidId = backendRut.length >= FOREIGN_ID_MIN_SIZE;
    }

    setLinea((prevLinea) => ({
      ...prevLinea,
      deudor: {
        ...deudorInitialState,
        rut: backendRut,
        pais: prevLinea.deudor.pais
      },
    }));
    if (isValidId) {
      latestRutRef.current = backendRut;
      
      debounceTimer.current = setTimeout(() => {
        const currentRut = latestRutRef.current;
        setIsSiipreloadLoading(true);
        
        // Para exportacion: solo revisa si el deudor existe en DB (sin preload SII)
        // Para domestico: preload=True para precargar datos SII
        const selectedPaisCode = paises.find(p => p.id === linea.deudor.pais)?.code || 'CL';
        const urlDeudores = isExportacion
          ? `${BASE_URL}${API.deudores}/?rut=${currentRut}&pais=${selectedPaisCode}`
          : `${BASE_URL}${API.deudores}/?rut=${currentRut}&preload=True`;
        
        get(client ? `${urlDeudores}&client_id=${client.id}` : urlDeudores).then((resp1) => {
          if (resp1.length === 1) {
            const existingDeudor = resp1[0];
            const { policies } = existingDeudor;
            
            // Check for policies related to the current policyId
            if (policies) {
              const arrayIdMovimiento = policies.filter(p => p[0] === parseInt(policyId, 10));
              
              // If we found related policies, fetch the movements
              if (arrayIdMovimiento.length > 0) {
                get(`${BASE_URL}${API.movimientosLineaCredito}/?linea_credito_id=${policies.filter(
                  p => p[0] === parseInt(policyId, 10))[0][1]}&pendientes=True`
                ).then((respMov) => {
                  setMovPreviosCount(respMov.length);
                  // If there are movements, get the status from the last one
                  if (respMov.length > 0) {
                    const lastItem = respMov[respMov.length - 1];
                    setLastMovement(lastItem.estado_data.nemotecnico);
                  }
                });
              }
            }
          if (currentRut === latestRutRef.current) {
            if (resp1.length === 1) {
              const existingDeudor = resp1[0];
              if (isExportacion) {
                existingDeudor.pais = existingDeudor.pais ? existingDeudor.pais : GEO_PAIS_CHILE_ID;
              }
              originalDeudorRef.current = pickDeudorCampos(existingDeudor);

              setLinea((prevLinea) => ({
                ...prevLinea,
                deudor: existingDeudor,
              }));
            
              if (existingDeudor.id) {
                setLoadingTiposDeudor(true);
                const urlLineas = `${BASE_URL}${API.lineasCredito}/?poliza_id=${policyId}&deudor_id=${existingDeudor.id}`;
                get(client ? `${urlLineas}&client_id=${client.id}` : urlLineas).then((resp2) => {
                  if (resp2.length === 1 && resp2[0].estado_data?.nemotecnico === ESTADOS_LINEAS.rechazada) {

                    const isApelable = resp2[0].balance.is_migration === false 
                      && apelable(resp2[0].balance.fecha_respuesta);
                  
                    setLinea((prevLinea) => ({
                      ...prevLinea,
                      tipo_deudor: resp2[0].tipo_deudor,
                      balance: {
                        ...linea.balance,
                        monto_vigente: resp2[0].balance.monto_vigente,
                        limite_apelacion: isApelable ? resp2[0].balance.monto_solicitado : null,
                        fecha_solicitud: resp2[0].balance.fecha_solicitud,
                      },
                      estado_data: resp2[0].estado_data,
                    }));
                  }
                  // Línea bloqueada
                  else if (resp2.length === 1 && resp2[0].estado_data?.nemotecnico === ESTADOS_LINEAS.bloqueado) {
                    setIsUnlock(true);
                    setLinea((prevLinea) => ({
                      ...prevLinea,
                      tipo_deudor: resp2[0].tipo_deudor,
                      balance: {
                        ...linea.balance,
                        monto_vigente: resp2[0].balance.monto_vigente,
                        monto_solicitado: resp2[0].balance.monto_otorgado_previo,
                        fecha_solicitud: resp2[0].balance.fecha_solicitud,
                      },
                      estado_data: resp2[0].estado_data,
                    }));
                  }
                  // Línea aprobada previa
                  else if (resp2.length === 1) {
                    setLinea((prevLinea) => ({
                      ...prevLinea,
                      tipo_deudor: resp2[0].tipo_deudor,
                      balance: {
                        ...linea.balance,
                        monto_vigente: resp2[0].balance.monto_vigente,
                        limite_apelacion: null,
                        fecha_solicitud: resp2[0].balance.fecha_solicitud,
                      },
                      estado_data: resp2[0].estado_data,
                    }));
                  }
                  // No existe línea aún
                  else {
                    setLinea((prevLinea) => ({
                      ...prevLinea,
                      tipo_deudor: null,
                      balance: {
                        ...linea.balance,
                        monto_vigente: 0,
                        limite_apelacion: null,
                        fecha_solicitud: null,
                      },
                      estado_data: null,
                    }));
                  }
                  setLoadingTiposDeudor(false);
                })
                .finally(() => {
                  setLoadingTiposDeudor(false);
                  // SII preload complete
                  setIsSiipreloadLoading(false);
                });
              } else {
                // Deudor doesn't exist in DB yet - for exportacion, immediately allow form editing
                if (isExportacion) {
                  setIsSiipreloadLoading(false);
                } else {
                  console.warn("Skipping lineas-credito request: Temporary deudor detected.");
                  setIsSiipreloadLoading(false);
                }
              }
            }
        }}
        // Deudor not found - for exportacion, immediately allow form editing
        if (resp1.length === 0 && isExportacion) {
          setIsSiipreloadLoading(false);
        }
        });
    }, 500);
    
      setrutDeudor(backendRut);
    }
  };

  const nuevasLineas = () => lineas.filter((elem) => !elem.id);

  const resetForm = () => {
    setEdicion(false);
    setDeudorStepComplete(false);
    setLinea({
      ...lineaInitialState,
    });
  };

  const getCamposDeudorModificados = () => {
    const original = originalDeudorRef.current;
    if (!linea.deudor.id || !original) return [];
    return Object.keys(DEUDOR_CAMPOS_CONFIRMACION).filter(
      (campo) => normalizeCampo(original[campo]) !== normalizeCampo(linea.deudor[campo]),
    );
  };

  const handleSaveDeudor = () => {
    const modificados = getCamposDeudorModificados();
    if (modificados.length > 0) {
      setCamposDeudorModificados(modificados);
      setShowDeudorChangeModal(true);
      return;
    }
    doSaveDeudor();
  };

  const doSaveDeudor = () => {
    setDeudorStepComplete(true);
    setSavingDeudor(true);
    const apiMethod = linea.deudor.id ? put : post;
    const url = linea.deudor.id
      ? `${BASE_URL}${API.deudores}/${linea.deudor.id}/`
      : `${BASE_URL}${API.deudores}/`;
    // Forzar pais en nulo cuando la poliza no sea de exportacion
    const isExportacion = poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO;
    const deudorData = {
      ...linea.deudor,
      pais: isExportacion ? linea.deudor.pais : null,
    };
    apiMethod(client ? `${url}?client_id=${client.id}` : url, deudorData)
      .then((resp) => {
        if ('error' in resp) {
          setErrorInForm(resp.error)
          setDisplayModalWarningBadRequest(true)
          setSavingDeudor(false)
        }
        else {
          setLineaProperty('deudor', resp)
          originalDeudorRef.current = pickDeudorCampos(resp)
          setSavingDeudor(false)
        }
      })
      .catch(() => {
        setErrorInForm("Error al realizar solicitud")
        setSavingDeudor(false)
        setDisplayModalWarningBadRequest(true)
      });
  };

  const handlePaisChange = (newPais) => {
    // Limpia todos los campos menos el pais
    setLinea((prevLinea) => ({
      ...prevLinea,
      deudor: {
        ...deudorInitialState,
        pais: newPais,
      },
    }));
    setDeudorStepComplete(false);
  };

  const handleSaveLinea = (e) => {
    e.preventDefault();
    const debtorExists = lineas.some(item => item.deudor.id === linea.deudor.id);

    if (isUnlock && lineas.length > 0) {
      // console.log("No se puede agregar otra línea porque ya existe una y el deudor no está desbloqueado.");
      return;
    }
    if (edicion) {
      setLineas(lineas.map((elem) => (elem.deudor.id === linea.deudor.id ? { ...linea } : elem)));
      resetForm();
    } else {
      if (debtorExists) {
        setShowDeudorExistsModal(true);
        console.log("Este deudor ya tiene una línea asignada.");
        return;
      }
      setLineas([linea, ...lineas]);
    }

    // Solo llamar a resetForm si no estamos en un caso de desbloqueo
    if (!isUnlock) {
      resetForm();
    }
  
    setSolicitada(true);
    setTotalMovPreviosCount(totalMovPreviosCount + movPreviosCount);
    setMovPreviosCount(0);
  };

  const handleSolicitada = () => {
    setSolicitada(false);
  };

  const handleEditLinea = (lineaToEdit) => {
    setEdicion(true);
    setLinea(lineaToEdit);
  };

  const handleDeleteLinea = (lineaToDelete) => {
    setLineas(lineas.filter((elem) => elem.deudor.id !== lineaToDelete.deudor.id));
    setStoredDeudorIds(prevIds => prevIds.filter(id => id !== lineaToDelete.deudor.id));
  };

  const toApiObject = (currentLine) => ({
    deudor_id: currentLine.deudor.id,
    poliza_id: policyId,
    tipo_deudor_id: currentLine.tipo_deudor.id,
    monto_solicitado: currentLine.balance.monto_solicitado,
    monto_vigente: currentLine.balance.monto_vigente,
    observacion: currentLine.balance.observacion,
    documentos: currentLine.balance.documentos.map((doc) => doc.uuid),
    carpeta_tributaria:
      currentLine.balance.carpeta_tributaria && currentLine.balance.carpeta_tributaria.uuid,
  });

  const solicitarCambios = async () => {
    const capturedCount = lineas.length;
    setCapturedDeudorId(lineas.length === 1 ? lineas[0].deudor.id : null);
    setSolicitandoCambios(true);
    setShowProgressModal(true);
    const nuevasLineasApi = nuevasLineas().map((elem) => toApiObject(elem));
    const url = `${BASE_URL}${API.lineasCredito}/`;

    const BATCH_SIZE = 10;
    const batches = [];

    for (let i = 0; i < nuevasLineasApi.length; i += BATCH_SIZE) {
      batches.push(nuevasLineasApi.slice(i, i + BATCH_SIZE));
    }

    setUploadProgress({ current: 0, total: batches.length });

    try {
      const allResults = [];

      for (let i = 0; i < batches.length; i++) {
        const batch = batches[i];
        const batchUrl = client 
          ? `${url}?client_id=${client.id}&is_carga_masiva=${isCargaMasiva}` 
          : url;

        const result = await Promise.allSettled([
          post(batchUrl, batch)
        ]);

        allResults.push(...result);
        setUploadProgress({ current: i + 1, total: batches.length });

        // pequeño delay para no matarlo
        if (i < batches.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      const hasError = allResults.some(result => result.status === 'rejected');

      if (hasError) {
        const rejected = allResults.find(result => result.status === 'rejected');
        const reason = rejected?.reason;
      
        let backendMessage = "El monto solicitado debe ser mayor al monto vigente de la línea.";
      
        if (reason instanceof Response) {
          try {
            const data = await reason.json();
            backendMessage = data.linea_credito || data.detail || backendMessage;
          } catch (e) {
            // Body no era json o no fue consumido, se va al default
          }
        }
      
        setErrorInForm(backendMessage);
        setDisplayModalWarningBadRequest(true);
      } else {
        setLineasCount(capturedCount);
        setLineas([]);
        setRequestedChanges(true);
      }
    } catch (error) {
      console.error("Error en solicitarCambios:", error);
      setErrorInForm("Ocurrió un error al solicitar cambios.");
      setDisplayModalWarningBadRequest(true);
    } finally {
      setSolicitandoCambios(false);
      setUploadProgress({ current: 0, total: 0 });
      setShowProgressModal(false);
    }
  };

  useEffect(() => {
    let timer;
    if (requestedChanges) {
      timer = setTimeout(() => {
        history.push({
          pathname: "/asegurado/lineas-credito/",
          state: { 
            fromCheckModal: true, 
            deudorId: capturedDeudorId,
            isExportacion: poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO,
          }
        });
        setRequestedChanges(false);
      }, 5000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [requestedChanges, history, storedDeudorIds, poliza.ramo_fecu_nemotecnico]);

  const save_scoring = async () => {
    try {

      const timestamp = new Date().getTime(); // Usaba timestamp para evitar el caché
      const primeraLinea = await get(`${BASE_URL}${API.lineasCredito}?client_id=${client.id}&isJudging=${true}&_=${timestamp}`);
      // const response = await get(`${BASE_URL}${API.lineasCredito}?client_id=${client.id}&_=${timestamp}`);
      // const primeraLinea = response[0];
      const balanceId = primeraLinea[0]?.balance?.id; // Extraer el balance.id


      // Verificar que el balanceId exista y establecerlo
      if (balanceId) {
        setIdNewLine(balanceId); // Guardamos el balanceId en el estado
      } else {
        console.error("No se pudo obtener el balance ID.");
      }

      //if (rutDeudor) {
      //  // Obtener el organizationId
      //  const orgResponse = await get(`${BASE_URL}${API.organizations}/?rut=${rutDeudor}`);
      //  const id = orgResponse[0]?.id;
//
      //  if (id) {
      //    const payload = {
      //      organization: id,
      //      type: 1, // Tipo fijo en 1
      //      rut: rutDeudor,
      //      reporte_consolidado_id: balanceId // Usar balanceId aquí
      //    };
//
      //    const url = `${BASE_URL}${API.clasificaciones}`;
//
      //    await post(url, payload);
      //    console.log(`Scoring creado`);
      //  }
      //} else {
      //  console.error("El rut no está definido.");
      //  setErrorInForm("El RUT debe estar definido antes de solicitar cambios.");
      // }
    } catch (error) {
      console.error("Error:", error);
      setErrorInForm("Ocurrió un error al obtener las líneas de crédito - Deudor no existente como Organización");
      setDisplayModalWarningBadRequest(true);
    }
  };

  useEffect(() => {
    const isExportacion = isExportacionFromUrl || poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO;
    
    if (isExportacion && paises.length === 0) {
      return;
    }
    
    // Only run this check when we have a valid deudor with an ID that wasn't manually entered
    if (linea.deudor && linea.deudor.id && linea.deudor.rut && !isSiipreloadLoading && !lastMovement) {
      const currentRut = linea.deudor.rut;

      const selectedPaisCode = paises.find(p => p.id === linea.deudor.pais)?.code || 'CL';
      const urlDeudores = isExportacion
        ? `${BASE_URL}${API.deudores}/?rut=${currentRut}&pais=${selectedPaisCode}`
        : `${BASE_URL}${API.deudores}/?rut=${currentRut}&preload=True`;
      get(client ? `${urlDeudores}&client_id=${client.id}` : urlDeudores).then((resp) => {
        if (resp.length === 1) {
          const existingDeudor = resp[0];
          const { policies } = existingDeudor;

          // Check for policies related to the current policyId
          if (policies) {
            const arrayIdMovimiento = policies.filter(p => p[0] === parseInt(policyId, 10));

            // If we found related policies, fetch the movements
            if (arrayIdMovimiento.length > 0) {
              get(`${BASE_URL}${API.movimientosLineaCredito}/?linea_credito_id=${policies.filter(
                p => p[0] === parseInt(policyId, 10))[0][1]}&pendientes=True`
              ).then((respMov) => {
                setMovPreviosCount(respMov.length);

                // If there are movements, get the status from the last one
                if (respMov.length > 0) {
                  const lastItem = respMov[respMov.length - 1];
                  setLastMovement(lastItem.estado_data.nemotecnico);
                }
              });
            }
          }
        }
      });
    }
  }, [linea.deudor.id, paises]);


  const procesarCarpetaTributaria = async () => {
    const requestBody = new FormData();
    let fileIndex = 0;

    lineas.forEach((linea) => {
      if (!linea.balance.carpeta_tributaria?.file) {
        return;
      }

      requestBody.append(`rut_${fileIndex}`, linea.deudor.rut);
      requestBody.append(`carpeta_${fileIndex}`, linea.balance.carpeta_tributaria.id);

      fileIndex++;
    });

    // No se incluyeron carpetas tributarias
    if (fileIndex === 0) {
      return;
    }

    try {
      await request('PUT', `${BASE_URL}${API.processCarpetaTributaria}/`, requestBody, true, {});
    } catch (error) {
      console.error('Error procesando carpetas tributarias:', error);
    }
  }

  const solicitarCambios_and_save_score = async () => {
    if (movPreviosCount > 0 || lastMovement === 'procesando' || lastMovement === 'pendiente') {
      setDisplayModalWarning(true);
      return;
    }
    
    await Promise.all([
      solicitarCambios(), // si no hay pendientes, avanza.
      procesarCarpetaTributaria(),
    ]);
    //await save_scoring();
  };


  const handleBatchUploadFinish = (resp) => {
    setIsCargaMasiva(true);
    setLineas((prevLinea) => [...prevLinea, ...resp.lineas]);
    setErrors(resp.errors);
  };

  const isPolizaVigente = () => {
    if (poliza) {
      if (poliza.emitido == true){
        const hoy = moment()
        const inicio = moment(poliza.inicio_vigencia)
        const termino = moment(poliza.termino_vigencia)
        return hoy.isBetween(inicio, termino, undefined, '[]');
      }
      else{
        return false
      }
    }
    return false;
  };
  const existenLineasPrevias = () => totalMovPreviosCount > 0;

  const clientName = client ? ` (${client.nombre})` : '';



  
  useEffect(() => {
    if (linea.deudor.id) {
      setStoredDeudorIds(prevIds => {
        if (!prevIds.includes(linea.deudor.id)) {
          return [...prevIds, linea.deudor.id];
        }
        return prevIds;
      });
    }
  }, [linea.deudor.id]);

  return (
    <div>
      <Col xl={{ offset: 2, size: 8 }} lg={{ offset: 1, size: 10 }}>
        <FormSection title={`Solicitud de Línea de Cliente${clientName}`}>
          <GridContainer columns="1fr 1fr" gap="10px 20px" alignItems="top">
            <FormGroup row>
              <Label for="poliza" sm={2} style={{ fontSize: '16px' }}>
                Póliza:
              </Label>
              <Col sm={8} style={{ paddingLeft: 0 }}>
                <Input
                  id="poliza"
                  plaintext
                  disabled
                  value={poliza.nemotecnico}
                  onChange={() => { }}
                />
              </Col>
            </FormGroup>
            <div />
            <div style={{ marginBottom: '30px' }}>
              <CreditLineForm
                linea={linea}
                edicion={edicion}
                maximoInnominados={poliza.balance && poliza.balance.maximo_innominados_amt}
                getUmbralMinimo={poliza.balance && poliza.balance.umbral_cobertura_amt}
                tiposDeudor={tiposDeudor}
                paises={paises}
                onPaisChange={handlePaisChange}
                handleTipoDeudorChange={(selectedOpt) =>
                  setLineaProperty('tipo_deudor', selectedOpt.value)
                }
                handleMontoSolicitadoChange={(values) =>
                  setLineaProperty('balance.monto_solicitado', values.floatValue)
                }
                handleSaveLinea={handleSaveLinea}
                handleEditionCancel={resetForm}
                loadingTiposDeudor={loadingTiposDeudor}
                setLineaProperty={setLineaProperty}
                setLinea={setLinea}
                handleDeudorRutChange={handleDeudorRutChange}
                handleSaveDeudor={handleSaveDeudor}
                savingDeudor={savingDeudor}
                clearDeudor={() => {
                  setLineaProperty('deudor', deudorInitialState);
                  originalDeudorRef.current = null;
                  setLinea(lineaInitialState);
                  setDeudorStepComplete(false);
                }}
                deudorStepComplete={deudorStepComplete}
                client={client}
                solicitada={solicitada}
                handleSolicitada={handleSolicitada}
                isUnlock={isUnlock}
                isPolizaVigente={isPolizaVigente}
                isSiipreloadLoading={isSiipreloadLoading}
                isOnBorrador={!!poliza.borrador}
                policyId={poliza && poliza.id}
                policyIsExportacion={isExportacionFromUrl || poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO}
                policyState={poliza.balance && poliza.balance.estado}
                policyTerminoVigencia={poliza && poliza.termino_vigencia}
                policyMoneda={poliza && poliza.moneda}
              />
            </div>
            
            {!isUnlock &&
              (!isExportacionFromUrl &&
                (poliza &&
                  poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_DOMESTICO_NEMOTECNICO)) && (
              <div>
                <CreditLineBatchLoad
                  policyId={policyId}
                  handleBatchUploadFinish={handleBatchUploadFinish}
                  errors={errors}
                  setErrors={setErrors}
                  lineas={lineas}
                  setLineas={setLineas}
                  isCargaMasiva={isCargaMasiva}
                  setIsCargaMasiva={setIsCargaMasiva}
                  maximoInnominadosAmt={poliza.balance && poliza.balance.maximo_innominados_amt}
                  getUmbralMinimo={poliza.balance && poliza.balance.umbral_cobertura_amt}

                />
              </div>
            )}
            <div style={{ gridColumn: '1 / 3' }}>
              <CreditLineTable
                lineas={lineas}
                tiposDeudor={tiposDeudor}
                handleEditLinea={handleEditLinea}
                handleDeleteLinea={handleDeleteLinea}
              />
            </div>
            <div style={{ gridColumn: '1 / 3' }}>
              {isUserHasProfile(LINEA_CREDITO_WRITE) && (
                <div className="float-right">
                  {showProgressModal && (
                    <div className="mb-2">
                      <div className="progress" style={{ width: '150px', height: '10px' }}>
                        <div 
                          className="progress-bar" 
                          style={{ 
                            width: `${uploadProgress.total > 0 ? Math.round((uploadProgress.current / uploadProgress.total) * 100) : 0}%` 
                          }} 
                        />
                      </div>
                      <small>
                        {uploadProgress.current} de {uploadProgress.total} lotes
                      </small>
                    </div>
                  )}
                  <SafeBtn
                    loading={solicitandoCambios}
                    onClick={() => {
                      if (existenLineasPrevias()) {
                        return setDisplayModalWarning(true);
                      }
                      return solicitarCambios_and_save_score();
                    }}
                    disabled={nuevasLineas().length === 0 || showProgressModal}
                    className="float-right"
                    color="orsan"
                    style={{ width: '150px', fontSize: '14px' }}
                  >
                    Solicitar
                  </SafeBtn>
                </div>
              )}
              <Button
                onClick={() => {
                  setLineas([]);
                  setTotalMovPreviosCount(0);
                  setLastMovement('');
                  setStoredDeudorIds(null);
                }}
                className="float-right"
                color="orsan-link"
                style={{ width: '100px', fontSize: '14px' }}
              >
                Limpiar
              </Button>
            </div>
          </GridContainer>
        </FormSection>
      </Col>
      <WarningModal
        isOpen={displayModalWarning}
        toggle={() => setDisplayModalWarning(false)}
        handleOk={() => { }}
        handleClearError={() => setDisplayModalWarning(false)}
        errorMsg={
          lastMovement === 'procesando' 
            ? `Su última solicitud está siendo procesada. No puede hacer una nueva solicitud hasta que se resuelva.`
            : lastMovement === 'pendiente'
            ? `Existen movimientos pendientes. No puede hacer una nueva solicitud hasta que se resuelvan.`
            : `No se puede realizar una nueva solicitud en este momento. Vuelva a intentarlo más tarde.`
        }
        confirmMsg=""
      />
      <WarningModal
        isOpen={displayModalWarningBadRequest}
        toggle={() => setDisplayModalWarningBadRequest(false)}
        handleOk={() => { }}
        handleClearError={() => setDisplayModalWarningBadRequest(false)}
        errorMsg={errorInForm}
        confirmMsg=""
      />
      <CheckModal
        isOpen={requestedChanges}
        toggle={() => setRequestedChanges(false)}
        handleOk={() => history.push({
          pathname: "/asegurado/lineas-credito/",
          state: {  
            fromCheckModal: true, 
            deudorId: capturedDeudorId,
            isExportacion: poliza.ramo_fecu_nemotecnico === RAMO_FECU_CREDITO_EXPORTACION_NEMOTECNICO,
          }
        })}
        okBtnText="OK"
        confirmMsg="Solicitud enviada con éxito"
        backdrop="static" // previene que el modal se cierre al hacer click fuera de este
      />
      <WarningModal
        isOpen={showNotFoundModal}
        toggle={() => { }}
        handleOk={() => { }}
        handleClearError={() => {
          history.push("/asegurado/lineas-credito/")
        }}
        errorMsg="Póliza crédito no encontrada"
        confirmMsg=""
      />
      <WarningModal
        isOpen={showDeudorExistsModal}
        toggle={() => setShowDeudorExistsModal(false)}
        handleOk={() => {}}
        handleClearError={() => {
          setShowDeudorExistsModal(false);
        }}
        errorMsg="Este deudor ya tiene una línea asignada."
        confirmMsg=""
      />
      <WarningModal
        isOpen={showDeudorChangeModal}
        toggle={() => setShowDeudorChangeModal(false)}
        handleOk={() => {
          setShowDeudorChangeModal(false);
          doSaveDeudor();
        }}
        okBtnText="Confirmar"
        confirmMsg={
          `Está modificando los datos registrados del deudor RUT ${linea.deudor.rut} `
          + `(${camposDeudorModificados.map((c) => DEUDOR_CAMPOS_CONFIRMACION[c]).join(', ')}). `
          + 'Estos cambios se aplicarán al DEUDOR en el sistema. '
          + 'Verifique que los datos corresponden al deudor y no a sus propios datos. ¿Desea continuar?'
        }
      />
    </div>
  );
};

CreditLine.propTypes = {
  policyId: PropTypes.string.isRequired,
  locationSearch: PropTypes.string.isRequired,
  client: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
  }),
  handleClienteChange: PropTypes.func.isRequired,
};

CreditLine.defaultProps = {
  client: null,
};

export default CreditLine;
